<app-header [title]="'NO_ACCESS' | translate"></app-header>
